import { createSlice } from '@reduxjs/toolkit'
import api from '../../api/index'
import { startLoading, stopLoading } from './loadingSlice'
import {
  failed,
//   success,
} from './snackSlice'
// import { fixNumbers } from '../../utils/getInitials'

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {},
  reducers: {
    topDashboardDataFetch: (state, { payload }) => {
      state.topData = payload
    },
    agesGroupFetch: (state, { payload }) => {
      state.ageGroup = payload
    },
    recentlyRegisteredFetch: (state, { payload }) => {
      state.recentlyRegistered = payload
    },
    recentlyPaymentFetch: (state, { payload }) => {
      state.recentlyPayment = payload
    },
    recentlyScholarshipFetch: (state, { payload }) => {
      state.recentlyScholarship = payload
    },
  },
})

export default dashboardSlice.reducer
export const {
  topDashboardDataFetch,
  agesGroupFetch,
  recentlyRegisteredFetch,
  recentlyPaymentFetch,
  recentlyScholarshipFetch,
} = dashboardSlice.actions

export const getTopDashboardData = () => (dispatch) => {
  const url = '/dashboard/GetTopDashboardData'

  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      if (res?.data) {
        dispatch(topDashboardDataFetch(res?.data?.data))
      }
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getAgesGroup = () => (dispatch) => {
  const url = '/dashboard/GetAgesGroup'

  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      if (res?.data) {
        dispatch(agesGroupFetch(res?.data?.data))
      }
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getRecentlyRegistered = () => (dispatch) => {
  // const toDate = new Date().toLocaleDateString().split('/').reverse()
  //   .join('-')
  // const fromDate = new Date(new Date().setDate(new Date().getDate() - 7))
  // .toLocaleDateString().split('/').reverse()
  // .join('-')

  const toDate = (new Date()).toISOString().split('T')[0]

  const fromDate = new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0]

  console.log('toDate', toDate)
  console.log('fromDate', fromDate)

  const url = `/dashboard/GetRecentlyRegistered?fromDate=${fromDate}&toDate=${toDate}`

  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      if (res?.data) {
        dispatch(recentlyRegisteredFetch(res?.data?.data))
      }
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getRecentlyPayments = () => (dispatch) => {
  const url = '/Payment?first=7&after=0'

  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      if (res?.data) {
        dispatch(recentlyPaymentFetch(res?.data?.data))
      }
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getRecentlyScholarship = () => (dispatch) => {
  const url = '/scholarship?first=6&after=0'

  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      if (res?.data) {
        dispatch(recentlyScholarshipFetch(res?.data?.data))
      }
      dispatch(stopLoading())
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const selectorTopData = (state) => state?.dashboard?.topData
export const selectorAgeGroup = (state) => state?.dashboard?.ageGroup
export const selectorRecentlyRegistered = (state) => state?.dashboard?.recentlyRegistered
export const selectorRecentlyPayment = (state) => state?.dashboard?.recentlyPayment
export const selectorRecentlyScholarship = (state) => state?.dashboard?.recentlyScholarship
